
import { dataFetcher } from 'core/services/requestHandler';   

const getEarningsData = async (data = {}, config = {}) => {
  return dataFetcher('earnings/getEarningData', data, {...config});
};
export { getEarningsData };
